import axios from 'axios'
import log from 'salvo-lite/log'
class LoadMore {
    constructor (theme, elem) {
        this.theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._text = elem.getAttribute('data-text')
        this._loading = elem.getAttribute('data-loading')
        this._newElements = elem.getAttribute('data-load-more')
        this._paginationWrapper = elem
        this._elementClass = document.querySelector('.template-blog') ? '.article-grid .single-article' : '.collection__product-grid .single-product'
        this._wrapper = document.querySelector('.template-blog') ? '.article-grid' : '.collection__product-grid'
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.innerHTML = this._text
        if (this._elem.classList.contains('visually-hidden')) {
            this._infiniteLoad()
        }
        this._elem.addEventListener('click', () => {
            this._elem.innerHTML = this._loading
            let scroll = parseInt(window.scrollY)
            this.loadMore(scroll)
        })
    }

    _infiniteLoad () {
        const self = this
        let triggered
        window.addEventListener('scroll', () => {
            const loadMoreButton = document.querySelector('[data-load-more]')
            const scrollDistance = window.pageYOffset || document.documentElement.scrollTop
            if (self._elem.offsetTop <= (scrollDistance + window.innerHeight - 400) && loadMoreButton) {
                if (triggered !== loadMoreButton.getAttribute('data-next-page')) {
                    triggered = loadMoreButton.getAttribute('data-next-page')
                    if (loadMoreButton.classList.contains('visually-hidden') && screen.width > 768) {
                        loadMoreButton.click()
                    } else {
                        loadMoreButton.addEventListener('click', e => {
                            loadMoreButton.click()
                        })
                    }
                }
            }
        })
    }

    loadMore (scroll) {
        const self = this
        const nextUrl = this._elem.getAttribute('data-next-page')

        axios.get(nextUrl).then(function (response) {
            // get new elements from response data
            const newElementsWrapper = document.createElement('div')
            newElementsWrapper.innerHTML = response.data
            const newMoreButton = newElementsWrapper.querySelector('[data-load-more]')
            const newElements = newElementsWrapper.querySelectorAll(self._elementClass)

            // update next page url
            self.updateNextPageUrl(newMoreButton)

            // add new elements to page
            self.addNewElements(newElements, nextUrl, scroll)
        })
    }

    updateNextPageUrl (nextButton) {
        if (nextButton) {
            const newNextPage = nextButton.getAttribute('data-next-page')
            const oldMoreButton = document.querySelector('[data-load-more]')
            oldMoreButton.setAttribute('data-next-page', newNextPage)
        } else {
            this._paginationWrapper.remove()
        }
    }

    addNewElements (els, url, scroll) {
        for (let i = 0; i < els.length; i++) {
            els[i].setAttribute('data-page', url)
            if (els[i].querySelector('[data-preload]')) {
                let preloads = els[i].querySelectorAll('[data-preload]')
                for (var p = 0; p < preloads.length; p++) {
                    preloads[p].setAttribute('src', preloads[p].getAttribute('data-preload'))
                    preloads[p].removeAttribute('data-preload')
                }
            }

            document.querySelector(this._wrapper).appendChild(els[i])
            this.theme.registerComponents(document.querySelectorAll(`[data-page="${url}"]`)[i])
            if (document.querySelector('.template-blog')) {
                let evt = new CustomEvent('masonry-update', {detail: els[i]})
                document.dispatchEvent(evt)
            }
            this._elem.innerHTML = this._text
        }
        window.scrollTo(0, scroll)
    }
}

export default LoadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/LoadMore.js